var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"theme":"light"}},[_c('header-nav'),_c('v-content',[_c('v-container',{attrs:{"fluid":""}},[_c('transition',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }